<template>
  <div class="limit-field">
    <el-radio-group v-model="limitField" @change="clearData">
      <el-radio :label="false">所有字段</el-radio>
      <el-radio :label="true">指定字段</el-radio>
    </el-radio-group>
    <div v-if="limitField" class="field-list">
      <div class="count">
        <span class="color-Gray_75">选择了{{ length }}个字段</span>
        <span class="btn-change pLeft16" @click="selectField">
          <i class="el-icon-edit"></i>
          修改字段
        </span>
      </div>
      <div>
        <div class="field-item" key="id">
          <div class="name">[关联表] ID</div>
          <div class="deep"></div>
          <div class="place"></div>
        </div>
        <div class="field-item" v-for="field in searchData.fieldInfos" :key="field.cid">
          <div class="name" v-tip>
            {{ fieldsInfoMap[field.cid] ? fieldsInfoMap[field.cid].name : "字段已删除" }}
          </div>
          <div class="deep">
            <el-select
              v-if="
                fieldsInfoMap[field.cid] &&
                  ['ref', 'staff', 'department', 'company', 'file'].includes(
                    fieldsInfoMap[field.cid]._type
                  )
              "
              v-model="field.deep"
              placeholder="请选择"
            >
              <el-option label="仅当前表" :value="0"></el-option>
              <el-option label="含关联表" :value="1"></el-option>
            </el-select>
          </div>
          <i class="el-icon-delete-solid pointer" @click="removeField(field)"></i>
        </div>
      </div>
    </div>
    <select-fields
      ref="selectFields"
      :key="searchData.sheetId"
      hide-sub-level
      from="search"
      @submit="updateFillFields"
    ></select-fields>
  </div>
</template>
<script>
import SelectFields from "@/views/Company/Manage/Project/TaskTemplate/EditDialog/SelectFields"
export default {
  name: "limitField",
  components: { SelectFields },
  props: {
    searchData: Object,
    fieldsInfoMap: Object
  },
  data() {
    return {
      limitField: false
    }
  },
  computed: {
    hasSelected() {
      return this.searchData.fieldInfos?.map(field => field.cid) || []
    },
    length() {
      return this.searchData.fieldInfos?.length + 1
    }
  },
  created() {
    this.limitField = this.searchData.fieldInfos !== null
  },
  methods: {
    selectField() {
      this.$refs.selectFields.open(this.searchData.sheetId, this.hasSelected)
    },
    removeField(field) {
      const index = this.searchData.fieldInfos.findIndex(d => d.cid === field.cid)
      this.searchData.fieldInfos.splice(index, 1)
    },
    updateFillFields(cids) {
      let cidFieldMap = this._.keyBy(this.searchData.fieldInfos, "cid")
      this.searchData.fieldInfos = cids.map(cid => {
        return cidFieldMap[cid] || { cid: cid, deep: 0 }
      })
    },
    clearData(val) {
      this.searchData.fieldInfos = val ? [] : null
    }
  }
}
</script>

<style lang="scss" scoped>
.limit-field {
  margin-top: 10px;
  .field-list {
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 13px;
    .count {
      margin-bottom: 10px;
      .btn-change {
        color: #2196f3;
        cursor: pointer;
      }
    }
    .field-item {
      display: flex;
      align-items: center;
      height: 36px;
      margin-bottom: 10px;
      .name {
        flex: 9;
        padding: 0 12px;
        background: #f8f8f8;
        color: #333;
        border-radius: 4px;
        height: 36px;
        line-height: 36px;
      }
      .deep {
        flex: 4;
        margin: 0 10px;
        ::v-deep {
          .el-input .el-input__inner {
            height: 36px;
            line-height: 36px;
            font-size: 13px;
            color: #333333;
          }
        }
      }
      .el-icon-delete-solid {
        padding: 3px;
        flex: 1;
        &:hover {
          color: #f44336;
        }
      }
      .place {
        padding: 3px;
        flex: 1;
      }
    }
  }
}
</style>
